import React from "react";

const GamesTent = ({ handleRedirect, tentSingle, arrow }) => {
  return (
    <>
      <div className="tent-wrapper games-tent-wrapper">
        <img src={tentSingle} alt="" />
      </div>
      <div
        className="inside-tent-door-wrapper"
        onClick={() => {
          handleRedirect("/games");
        }}
      >
        <img src={arrow} alt="" className="arrow-icon" />
      </div>
      <div className="games-tent-text-wrapper"></div>
    </>
  );
};

export default GamesTent;
